"use strict";

exports.__esModule = true;
exports.default = void 0;

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function registerPlugin(Theta, Hls) {
    var Logger = Theta.getLogger();
    var isPeeringEnabled = true;
    var md5 = window.md5;

    var ThetaHlsJsFragmentLoader = /*#__PURE__*/function (_Hls$DefaultConfig$lo) {
        _inherits(ThetaHlsJsFragmentLoader, _Hls$DefaultConfig$lo);

        var _super = _createSuper(ThetaHlsJsFragmentLoader);

        function ThetaHlsJsFragmentLoader() {
            _classCallCheck(this, ThetaHlsJsFragmentLoader);

            return _super.apply(this, arguments);
        }

        _createClass(ThetaHlsJsFragmentLoader, [{
            key: "integrityCheck",
            //FIXME this is should store the etag and length PER url.
            value: function integrityCheck(data) {
                Logger.log('integrityCheck etag=' + this.segmentEtag);

                if (this.segmentEtag) {
                    var recvChecksum = md5(data); // etag

                    var segmentEtag = this.segmentEtag[0] === '"' ? this.segmentEtag.substring(1, this.segmentEtag.length - 1) : this.segmentEtag;
                    Logger.log('verifying md5 checksum of the segment md5sum=' + recvChecksum);
                    return recvChecksum === segmentEtag;
                }

                return true;
            }
        }, {
            key: "load",
            value: function load(ctx, config, callbacks) {
                var _this = this;

                Logger.info("URL " + ctx.url + " Range end " + ctx.rangeEnd);
                Logger.info("ctx: ", ctx); // Logger.info(`context: `, ctx);

                if (this.thetaCtx.cache.has(ctx.url + ctx.rangeEnd)) {
                    Logger.info("load from cache - ", ctx.url, ctx.rangeEnd);

                    _get(_getPrototypeOf(ThetaHlsJsFragmentLoader.prototype), "load", this).call(this, ctx, config, callbacks);
                } else if (this.thetaCtx.p2p.id === null) {
                    Logger.info('not connected to peerjs, load from CDN...');
                    this.loadFromCDN_old(ctx, config, callbacks); // this.loadFromCDN(ctx, config, callbacks, data);
                } else if (this.thetaCtx.p2p.useCDN && !isPeeringEnabled) {
                    Logger.info('configuration has useCDN enabled, load from CDN...');
                    this.loadFromCDN_old(ctx, config, callbacks); // this.loadFromCDN(ctx, config, callbacks, data);
                } else {
                    var p2pObj = this.thetaCtx.p2p;
                    var playerStats = this.thetaCtx.playerStats;
                    var self = this;

                    if (Object.keys(p2pObj.peers).length === 0) {
                        Logger.info("no peer yet for " + p2pObj.id + ", load from UCN");
                        this.tryLoadFromUCN(ctx, config, callbacks); // this.loadFromCDN(ctx, config, callbacks, data);
                    } else {
                        var probeStartTime = Math.floor(Date.now());
                        var probeTimeout = this.thetaCtx.p2p.probeTimeout; // TODOs: use regular expression from config to handle URLs

                        var newUrl = self._getNewUrl(ctx.url); // let newUrl = self.thetaCtx.p2p.videoId === 'cjhellothetatestnet' ? self._changeCJUrl(ctx.url) : ctx.url;


                        Logger.info("New URL before probe is: ", newUrl, ctx.rangeEnd);
                        var retryTimes = this._getCDNLoadedPercent(p2pObj.counterMap) > 0.5 ? Math.ceil(Math.random() * 6) - 3 : Math.ceil(Math.random() * 3) + 1;
                        Logger.info('IMPROVE DEBUG - p2p object before probe is:', p2pObj.counterMap);
                        p2pObj.probeFromPeerWithTimeout(newUrl + ctx.rangeEnd, probeTimeout, 1, retryTimes).then(function (response) {
                            Logger.info('SPLIT DEBUG - response after probe:', response);
                            var startTime = Math.floor(Date.now());
                            Logger.info("probeFromPeerWithTimeout - fragment " + (newUrl + ctx.rangeEnd) + " found from peer " + response.peerid);
                            var peerid = response.peerid;
                            playerStats.processFragmentReq(peerid, 'probe_req_overview_replied');
                            playerStats.processProbeReq(peerid, startTime - probeStartTime); // TODO: set fragment timeout back to dynamic config
                            //const factor = ctx.frag.duration > 3 ? 0.8 : 0.5;

                            var factor = p2pObj.failoverFactor;
                            var fragmentTimeout = Math.floor(ctx.frag.duration * 1000 * factor);
                            Logger.info("IMPROVE DEBUG - duration:" + ctx.frag.duration + ", factor:" + factor + ", fragment timeout:" + fragmentTimeout);
                            var totalNum = 5;
                            var data = new Array(totalNum + 1);
                            p2pObj.loadFromSpecificPeerWithTimeout(newUrl + ctx.rangeEnd, peerid, fragmentTimeout, totalNum, data).then(function (resp) {
                                Logger.log('IMPROVE DEBUG - resp after load from peer:', resp);
                                var res;
                                resp.forEach(function (r) {
                                    if (r !== undefined) res = r;
                                });

                                if (res.result === 'kOK') {
                                    Logger.log('SPLIT DEBUG - kOk res of loadFromSpecificPeerWithTimeout:', res);
                                    Logger.log('SPLIT DEBUG - data in kOk:', data);
                                    Logger.log('SPLIT DEBUG - ctx in kOK:', ctx); // return Promise.reject('Reject to corner case');

                                    Logger.warn("IMPROVE DEBUG [BL] - Load from peer success, updating the get fragment results map");
                                    p2pObj.updateGetFragResults(peerid, 'success', 5);

                                    _this.loadFromPeer(ctx, res, peerid, playerStats, startTime, p2pObj, callbacks, data, config);
                                } else {
                                    Logger.warn("remote peer " + peerid + " reject getFragment req, try CDN");
                                    Logger.warn("IMPROVE DEBUG [BL] - Load from peer failed, updating the get fragment results map");
                                    p2pObj.updateGetFragResults(peerid, 'failed', 5);
                                    playerStats.processFragmentReq(peerid, 'fragment_req_rejected');

                                    _this.tryLoadFromUCN(ctx, config, callbacks); // this.loadFromCDN(ctx, config, callbacks, data)

                                }
                            }).catch(function (error) {
                                Logger.warn("loadFromSpecificPeer gets timeout, " + ctx.url + " try CDN  - " + peerid);
                                var newData = data.slice(0);
                                newData.invoice = data.invoice;
                                Logger.log('IMPROVE DEBUG - newData in catch:', newData);
                                if (error.message) Logger.error('error message -', error.message);else Logger.error('error without msg -', error);
                                var loadedSeg = 0;
                                newData.forEach(function (d) {
                                    if (d && typeof d !== 'number') loadedSeg++;
                                });
                                Logger.info('IMPROVE DEBUG - loaded segment length:', loadedSeg);

                                if (!newData[newData.length - 1]) {
                                    p2pObj.updateGetFragResults(peerid, 'failed', 5);
                                    playerStats.processFragmentReq(peerid, 'fragment_req_timeout');
                                    Logger.log('SPLIT DEBUG - load from cdn use the old function.');

                                    _this.tryLoadFromUCN(ctx, config, callbacks);
                                } else {
                                    var tmp = newData.reduce(function (sum, newData) {
                                        return self._appendBuffer(sum, newData);
                                    }, new ArrayBuffer());
                                    p2pObj.updateGetFragResults(peerid, 'success', loadedSeg);
                                    p2pObj.updateGetFragResults(peerid, 'failed', totalNum - loadedSeg);

                                    if (tmp.byteLength === newData[newData.length - 1]) {
                                        Logger.log('SPLIT DEBUG - [corner case] In corner case!');
                                        var res = {
                                            'data': tmp,
                                            'invoice': newData.invoice,
                                            'totalLength': tmp.byteLength,
                                            'type': 'fragment',
                                            'url': ctx.url
                                        };

                                        _this.loadFromPeer(ctx, res, peerid, playerStats, startTime, p2pObj, callbacks);
                                    } else {
                                        (function () {
                                            // Handle load part from peer
                                            // this.loadFromPeer(ctx, resp, peerid, playerStats, startTime, p2pObj, callbacks);
                                            var unloadSegment = [];

                                            for (var i = 0; i < newData.length; i++) {
                                                if (newData[i] === undefined) unloadSegment.push(i);
                                            }

                                            Logger.info('IMPROVE DEBUG - unloadSegment:', unloadSegment);
                                            playerStats.processFragmentReq(peerid, 'fragment_req_timeout');

                                            _this.loadPartFromPeer(ctx.url, newData, tmp.byteLength, peerid, fragmentTimeout, playerStats, p2pObj);

                                            ctx.totalNum = totalNum;

                                            var _loop = function _loop(_i) {
                                                var promise = new Promise(function (resolve, reject) {
                                                    setTimeout(function () {
                                                        var tmpCtx = Object.assign({}, ctx);
                                                        var tmpCb = Object.assign({}, callbacks);
                                                        resolve(_this.loadFromCDN(tmpCtx, unloadSegment[_i], tmpCb, newData));
                                                        Logger.log('IMPROVE DEBUG - In part CDN setTimeout times:', _i);
                                                    }, _i * fragmentTimeout / 10);
                                                    Logger.log('IMPROVE DEBUG - In part CDN Timeout:', _i * fragmentTimeout / 10);
                                                });
                                                Logger.log('IMPROVE DEBUG - In part CDN in loop times:', _i);
                                            };

                                            for (var _i = 0; _i < unloadSegment.length; _i++) {
                                                _loop(_i);
                                            }
                                        })();
                                    }
                                }
                            });
                        }).catch(function (error) {
                            Logger.warn("probeFromPeerWithTimeout ends, " + probeTimeout + " timeout");
                            Logger.warn("probeFromPeerWithTimeout ends with err: ", error);
                            var playerStats = _this.thetaCtx.playerStats;
                            if (error.type === 'timeout') playerStats.processFragmentReq(null, 'probe_req_overview_timeout');else playerStats.processFragmentReq(null, 'probe_req_overview_notCached');

                            _this.tryLoadFromUCN(ctx, config, callbacks); // this.loadFromCDN(ctx, config, callbacks, data);

                        });
                    }
                }
            }
        }, {
            key: "loadFromCache",
            value: function loadFromCache(ctx, config, callbacks) {
                var url = ctx.url + ctx.rangeEnd;
                Logger.info("Serving from cache: ", url);
                var cache = this.thetaCtx.cache; //Ensure cachedItem is a valid object before digging in and grabbing the first element

                var cachedItem = cache.get(url);
                Logger.info("cachedItem: ", cachedItem);
                var cachedData = null;
                var cachedStats = null;

                if (cachedItem !== null && cachedItem !== undefined) {
                    cachedData = cachedItem[0].data.slice(0);
                    cachedStats = cachedItem[1];
                }

                var response = {
                    data: cachedData,
                    url: ctx.url
                };
                Logger.info("response: ", response);
                Logger.info("cachedData: ", cachedData);
                Logger.info("response: ", response);
                callbacks.onSuccess(response, cachedStats, ctx);
            }
        }, {
            key: "tryLoadFromUCN",
            value: function tryLoadFromUCN(ctx, config, callbacks) {
                var _this2 = this;

                Logger.info("Loading url: ", ctx.url);

                if (this.thetaCtx.p2p.useUCN) {
                    var ucn = this.thetaCtx.p2p.ucn; // const streamId = ucn.stream_map[this.thetaCtx.p2p.videoId]

                    var trackerUrl = "https://" + ucn.host + ":8080/live/" + this.thetaCtx.p2p.videoId + "/ucnmap.json";
                    ctx.originalUrl = ctx.url;
                    ctx.url = this._getNewUrl(ctx.url);
                    this.getUcnMap(trackerUrl, ctx.url).then(function (res) {
                        var ucnMap = res;
                        ctx.ucnMap = Object.assign({}, ucnMap);
                        ctx.cdnUrl = ctx.url;
                        ctx.url = "https://" + ucn.host + ":8080/live/" + ucnMap[ctx.cdnUrl]; // ctx.maxNum = this.thetaCtx.p2p.rangeNumber ? this.thetaCtx.p2p.rangeNumber : 1;

                        _this2.loadFromUCN(ctx, config, callbacks);
                    }).catch(function (err) {
                        Logger.info('getUcnMap returns an error: ', err);
                        Logger.info("getUcnMap didn't have the key, load from CDN");
                        ctx.url = ctx.originalUrl;

                        _this2.loadFromCDN_old(ctx, config, callbacks);
                    });
                } else {
                    Logger.info("useUCN is false, load from CDN");
                    this.loadFromCDN_old(ctx, config, callbacks);
                }
            }
        }, {
            key: "getUcnMap",
            value: function getUcnMap(trackerUrl, url) {}
        }, {
            key: "loadPartFromPeer",
            value: function loadPartFromPeer(url, data, dataLength, peerid, fragmentTimeout, playerStats, p2pObj) {
                Logger.log('SPLIT DEBUG - IN load part from peer');
                Logger.log('SPLIT DEBUG - data', data);
                Logger.log('SPLIT DEBUG - url', url);
                Logger.log('SPLIT DEBUG - peerid', peerid);
                var peerAddress = null;

                if (data.invoice) {
                    peerAddress = data.invoice.address;
                }

                this.thetaCtx.trigger(Theta.Events.TRAFFIC, {
                    type: Theta.TrafficType.P2P_INBOUND,
                    stats: {
                        size: dataLength
                    },
                    peer: {
                        id: peerid,
                        address: peerAddress
                    }
                });
                playerStats.processFragment(url, 'fromPeer', dataLength, fragmentTimeout);
                playerStats.processFragmentReq(peerid, 'fragment_req_replied');
                var conn = p2pObj.peers[peerid]; /// send payment,

                try {
                    if (data.invoice) {
                        if (p2pObj.shouldSendPayment(data, peerid)) {
                            Logger.log("SPLIT DEBUG - Sending payment to " + data.invoice.address);
                            p2pObj.sendPayment(data.invoice, conn);
                        } else {
                            Logger.log("SPLIT DEBUG - Should not send payment. Skipping payment.");
                        }
                    } else {
                        Logger.log('SPLIT DEBUG - Skip payment: {"msg": "Error: Anonymous user"}');
                    }
                } catch (e) {
                    Logger.error('Error sending payment: ', e);
                }
            }
        }, {
            key: "loadFromPeer",
            value: function loadFromPeer(ctx, resp, peerid, playerStats, startTime, p2pObj, callbacks) {
                Logger.info("fragment " + resp.url + " received from peer " + peerid);
                var response = {
                    url: resp.url,
                    data: resp.data
                };
                var stats = {
                    size: resp.data.byteLength,
                    loaded: resp.data.byteLength,
                    trequest: performance.now()
                };
                var endTime = Math.floor(Date.now());
                var peerAddress = null;
                Logger.info("getFragment from peer, takes " + (endTime - startTime) + " ms");

                if (!this.integrityCheck(response.data.slice(0))) {
                    Logger.error('segment integrity check (from peer) fails, skip loading');
                    return;
                }

                if (resp.invoice) {
                    peerAddress = resp.invoice.address;
                }

                this.thetaCtx.trigger(Theta.Events.TRAFFIC, {
                    type: Theta.TrafficType.P2P_INBOUND,
                    stats: {
                        size: response.data.byteLength
                    },
                    peer: {
                        id: peerid,
                        address: peerAddress
                    }
                });

                var newUrl = this._getNewUrl(ctx.url);

                Logger.info('Key in the cache from peers:', newUrl + ctx.rangeEnd);
                this.thetaCtx.cache.set(newUrl + ctx.rangeEnd, [{
                    data: resp.data.slice(0),
                    url: resp.url
                }, stats, ctx]);
                playerStats.processFragment(ctx.url, 'fromPeer', resp.data.byteLength, endTime - startTime);
                playerStats.processFragmentReq(peerid, 'fragment_req_replied');
                var conn = p2pObj.peers[peerid]; /// send payment,

                try {
                    if (resp.invoice) {
                        Logger.debug("Sending payment to " + resp.invoice.address);
                        p2pObj.sendPayment(resp.invoice, conn);
                    } else {
                        Logger.debug('Skip payment: {"msg": "Error: Anonymous user"}');
                    }
                } catch (e) {
                    Logger.error('Error sending payment: ', e);
                } //this.thetaCtx.theta.sendServiceCert(resp.theta_address);


                callbacks.onSuccess(response, stats, ctx);
            }
        }, {
            key: "loadFromCDN",
            value: function loadFromCDN(context, index, callbacks, data) {
                var start_time = Math.floor(Date.now());
                var self = this;
                var xhr = new XMLHttpRequest();

                try {
                    xhr.open('GET', context.url, true);
                } catch (e) {
                    // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
                    callbacks.onError({
                        code: xhr.status,
                        text: e.message
                    }, context, xhr);
                    return;
                }

                var length = data[data.length - 1];
                context.rangeStart = Math.floor(length * (index / context.totalNum));
                if (index === context.totalNum) context.rangeEnd = length;else context.rangeEnd = Math.floor(length * ((index + 1) / context.totalNum)) - 1;
                Logger.info("IMPROCE DEBUG - start:" + context.rangeStart + ", end:" + context.rangeEnd + ", index:" + index + ", total:" + context.totalNum);
                if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + context.rangeEnd);
                xhr.responseType = context.responseType;
                xhr.callbacks = callbacks;
                var playerStats = this.thetaCtx.playerStats;
                var p2pObj = this.thetaCtx.p2p;

                xhr.onload = function (evt) {
                    Logger.info(xhr.response);
                    var res = xhr.response; // Note: not oReq.responseText

                    if (res) {
                        var originCallbacks = Object.assign({}, callbacks);
                        var onSuccess = originCallbacks.onSuccess;
                        var cache = self.thetaCtx.cache;
                        var stats = {
                            size: res.byteLength,
                            loaded: res.byteLength,
                            trequest: performance.now()
                        };

                        xhr.callbacks.onSuccess = function (response, stats, ctx) {
                            Logger.info('On Success ctx: ', ctx);
                            p2pObj.updateGetFragResults('CDN', 'success', 1);
                            var end_time = Math.floor(Date.now());
                            var timeTaken = end_time - start_time;
                            Logger.info("getFragment from CDN, " + response.data.byteLength + " bytes takes " + timeTaken + " ms");
                            playerStats.processFragment(ctx.url + 'undefined', 'fromCDN', response.data.byteLength, end_time - start_time);

                            if (!self.integrityCheck(response.data.slice(0))) {
                                Logger.error('segment integrity check (from CDN) fails, skip loading');
                                return;
                            } // TODOs: use regular expression from config to handle URLs


                            var newUrl = self._getNewUrl(ctx.url);

                            Logger.info("New URL before set cache is: ", newUrl);
                            self.thetaCtx.trigger(Theta.Events.TRAFFIC, {
                                type: Theta.TrafficType.CDN,
                                stats: {
                                    size: response.data.byteLength
                                },
                                peer: null
                            });
                            data[index] = response.data;
                            Logger.log('IMPROVE DEBUG - change data[index]:', index, data[index]);
                            Logger.log('SPLIT DEBUG - data before newRes:', data);

                            if (self._checkData(data)) {
                                Logger.log('IMPROVE DEBUG - check data returns true:', data);
                                var newRes = {
                                    url: response.url,
                                    data: data.reduce(function (sum, data) {
                                        return self._appendBuffer(sum, data);
                                    }, new ArrayBuffer())
                                };
                                cache.set(newUrl + 'undefined', [{
                                    data: newRes.data.slice(0),
                                    url: response.url
                                }, stats, ctx]);
                                Logger.log('SPLIT DEBUG - is newRes data length match:', newRes.data.byteLength === length);
                                Logger.log('SPLIT DEBUG - newRes:', newRes);
                                onSuccess(newRes, stats, context);
                            } else {
                                Logger.log('IMPROVE DEBUG - check data returns false:', data);
                            }
                        };

                        var response = {
                            url: xhr.responseURL,
                            data: res
                        };
                        xhr.onreadystatechange = self.readystatechange.bind(self);
                        xhr.callbacks.onSuccess(response, stats, context);
                    }
                };

                xhr.send();
            }
        }, {
            key: "readystatechange",
            value: function readystatechange(event) {
                _get(_getPrototypeOf(ThetaHlsJsFragmentLoader.prototype), "readystatechange", this).call(this, event);
            }
        }, {
            key: "_getSequence",
            value: function _getSequence(num) {
                var res = [];

                for (var i = 0; i < num; i++) {
                    res[i] = i;
                }

                res = this._shuffle(res);
                return res;
            }
        }, {
            key: "_shuffle",
            value: function _shuffle(arr) {
                var current = arr.length;
                var temp;
                var index;

                while (current > 0) {
                    // Pick a random index
                    index = Math.floor(Math.random() * current);
                    current--;
                    temp = arr[current];
                    arr[current] = arr[index];
                    arr[index] = temp;
                }

                return arr;
            }
        }, {
            key: "_appendBuffer",
            value: function _appendBuffer(buffer1, buffer2) {
                if (!buffer1 || !buffer1.byteLength) return buffer2;
                if (!buffer2 || !buffer2.byteLength) return buffer1;
                var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
                tmp.set(new Uint8Array(buffer1), 0);
                tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
                return tmp.buffer;
            }
        }, {
            key: "_checkData",
            value: function _checkData(data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i] === undefined) {
                        return false;
                    }
                }

                return true;
            }
        }, {
            key: "_changeCJUrl",
            value: function _changeCJUrl(url) {
                var tmp = url.split('/media_');
                var firstPart = tmp[0];
                var secondPart = tmp[1].split('_')[1];
                return firstPart + '/media_' + secondPart;
            }
        }, {
            key: "_byPassQueryUrl",
            value: function _byPassQueryUrl(url) {
                var res = url;

                if (url.includes('.ts?')) {
                    var tmp = url.split('.ts?');
                    res = tmp[0] + '.ts';
                }

                return res;
            } // _setCache(cache, response, stats, ctx) {
            //   // const cdnUrl = ctx.cdnUrl ? ctx.cdnUrl : this._getCDNUrl(ctx.url, ctx.ucnMap);
            //   const cdnUrl = this._getCDNUrl(ctx.url, ctx.ucnMap);
            //   Logger.info(`CDN url in set cache is: `, cdnUrl);
            //   const byteLength = Math.round(response.data.byteLength / ctx.maxNum);
            //   Logger.info(`Byte length in set cache is: `, byteLength);
            //   Logger.info(`ctx max number: `, ctx.maxNum);
            //   if (ctx.maxNum && ctx.maxNum !== '') {
            //     for (let i = 0; i < ctx.maxNum; i++) {
            //       const endPoint = i === ctx.maxNum - 1 ? response.data.byteLength : (i + 1) * byteLength;
            //       Logger.info(`Data's key in cache is: `, cdnUrl + i);
            //       Logger.info(`Data from ${i * byteLength} to ${endPoint} in cache: `, response.data.slice(i * byteLength, endPoint));
            //       cache.set(cdnUrl + i, [{ data: response.data.slice(i * byteLength, endPoint), url: response.url }, stats, ctx]);
            //     }
            //   } else {
            //     cache.set(ctx.url, [{ data: response.data.slice(0), url: response.url }, stats, ctx]);
            //   }
            // }

        }, {
            key: "_getCDNUrl",
            value: function _getCDNUrl(url, map) {
                // TODO: change '/live/' to configurable
                var val = url.split('/live/')[1];
                Logger.info("In get CDN url, url is: " + url + ". val = " + val);
                var res = '';
                res = map ? Object.keys(map).find(function (key) {
                    return map[key] === val;
                }) : '';
                Logger.log("Get CDN url: ", res);
                return res;
            }
        }, {
            key: "_getNewUrl",
            value: function _getNewUrl(url) {
                var newUrl = url;

                if (this.thetaCtx.p2p.videoId === 'cjhellothetatestnet') {
                    newUrl = this._changeCJUrl(url);
                } else if (this.thetaCtx.p2p.segUrlBypassQuery) {
                    newUrl = this._byPassQueryUrl(url);
                }

                newUrl = this._byPassQueryUrl(newUrl);
                return newUrl;
            }
        }, {
            key: "loadFromUCN",
            value: function loadFromUCN(ctx, config, callbacks) {
                var _this3 = this;

                Logger.info("ThetaHlsJsFragmentLoader: loadFromUCN"); // Logger.info(`Loading url: `, ctx.url, ctx.rangeNum);

                var self = this;
                var cache = this.thetaCtx.cache;
                var onSuccess = callbacks.onSuccess;
                var start_time = Math.floor(Date.now());
                var playerStats = this.thetaCtx.playerStats;

                callbacks.onSuccess = function (response, stats, ctx) {
                    var end_time = Math.floor(Date.now());
                    var timeTaken = end_time - start_time;
                    Logger.info("getFragment from UCN, " + response.data.byteLength + " bytes takes " + timeTaken + " ms");
                    playerStats.processFragment(ctx.url, 'fromPeer', response.data.byteLength, end_time - start_time);

                    if (!_this3.integrityCheck(response.data.slice(0))) {
                        Logger.error('segment integrity check (from UCN) fails, skip loading');
                        return;
                    } // self._setCache(cache, response, stats, ctx);


                    var newUrl = self._getCDNUrl(ctx.url, ctx.ucnMap);

                    cache.set(newUrl + ctx.rangeEnd, [{
                        data: response.data.slice(0),
                        url: response.url
                    }, stats, ctx]);

                    _this3.thetaCtx.trigger(Theta.Events.TRAFFIC, {
                        type: Theta.TrafficType.P2P_INBOUND,
                        stats: {
                            size: response.data.byteLength
                        },
                        peer: null
                    });

                    onSuccess(response, stats, ctx);
                };

                _get(_getPrototypeOf(ThetaHlsJsFragmentLoader.prototype), "load", this).call(this, ctx, config, callbacks);
            }
        }, {
            key: "loadFromCDN_old",
            value: function loadFromCDN_old(ctx, config, callbacks) {
                var _this4 = this;

                Logger.info("ThetaHlsJsFragmentLoader: loadFromCDN");
                Logger.info("Loading url: ", ctx.url, ctx.rangeEnd);
                var cache = this.thetaCtx.cache;
                var onSuccess = callbacks.onSuccess;
                var start_time = Math.floor(Date.now());
                var playerStats = this.thetaCtx.playerStats;
                var p2pObj = this.thetaCtx.p2p;
                var self = this;

                callbacks.onSuccess = function (response, stats, ctx) {
                    Logger.info('On Success ctx: ', ctx.rangeEnd, ctx);
                    Logger.info('IMPROVE DEBUG - In old cdn, p2p object:', p2pObj);
                    p2pObj.updateGetFragResults('CDN', 'success', 5);
                    var end_time = Math.floor(Date.now());
                    var timeTaken = end_time - start_time;
                    Logger.info("getFragment from CDN, " + response.data.byteLength + " bytes takes " + timeTaken + " ms");
                    playerStats.processFragment(ctx.url, 'fromCDN', response.data.byteLength, end_time - start_time);

                    if (!_this4.integrityCheck(response.data.slice(0))) {
                        Logger.error('segment integrity check (from CDN) fails, skip loading');
                        return;
                    }

                    var newUrl = self._getNewUrl(ctx.url); // let newUrl = self.thetaCtx.p2p.videoId === 'cjhellothetatestnet' ? self._changeCJUrl(ctx.url) : ctx.url;


                    Logger.info("New URL before set cache is: ", newUrl, ctx.rangeEnd);
                    cache.set(newUrl + ctx.rangeEnd, [{
                        data: response.data.slice(0),
                        url: response.url
                    }, stats, ctx]);

                    _this4.thetaCtx.trigger(Theta.Events.TRAFFIC, {
                        type: Theta.TrafficType.CDN,
                        stats: {
                            size: response.data.byteLength
                        },
                        peer: null
                    });

                    onSuccess(response, stats, ctx);
                };

                _get(_getPrototypeOf(ThetaHlsJsFragmentLoader.prototype), "load", this).call(this, ctx, config, callbacks);
            }
        }, {
            key: "_getCDNLoadedPercent",
            value: function _getCDNLoadedPercent(counterMap) {
                var cdnNum = counterMap['CDN'] ? counterMap['CDN'].success : 0;
                var peerNum = 0;
                Object.keys(counterMap).forEach(function (id) {
                    if (id !== 'CDN') peerNum += counterMap[id].success;
                });
                var total = peerNum + cdnNum;
                Logger.info("IMPROVE DEBUG - calc cdn percentage: peerNum:" + peerNum + ", cdnNum:" + cdnNum);
                return total ? cdnNum / total : 1;
            }
        }], [{
            key: "toggleUseCDN",
            value: function toggleUseCDN() {
                isPeeringEnabled = !isPeeringEnabled;
            }
        }, {
            key: "isPeeringEnabled",
            get: function get() {
                return isPeeringEnabled;
            },
            set: function set(peering) {
                isPeeringEnabled = peering;
            }
        }]);

        return ThetaHlsJsFragmentLoader;
    }(Hls.DefaultConfig.loader);

    Theta.registerPlugin('hlsjs', ThetaHlsJsFragmentLoader);
}

// if (window && window.Theta && window.Hls) {
//     registerPlugin(window.Theta, window.Hls);
// }

var hls = {
    registerPlugin: registerPlugin
};
var _default = hls;
exports.default = _default;
